
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gcAZd", function(module, exports) {
$parcel$export(module.exports, "JSM_DEFAULT_BILLING_CYCLE", function () { return $ff47f9ee8d194adc$export$be354061b07829a8; });
$parcel$export(module.exports, "JSM_DEFAULT_UNIT_COUNT", function () { return $ff47f9ee8d194adc$export$2295858875312a6f; });
$parcel$export(module.exports, "JSM_MIN_ENTERPRISE_USER_COUNT", function () { return $ff47f9ee8d194adc$export$66d53803b4a2565a; });
$parcel$export(module.exports, "jsmOfferingSkus", function () { return $ff47f9ee8d194adc$export$38631f866342776a; });
$parcel$export(module.exports, "jsmOfferingSkusArray", function () { return $ff47f9ee8d194adc$export$efd16829e921ffb8; });
$parcel$export(module.exports, "jsmPlanLimitConfigs", function () { return $ff47f9ee8d194adc$export$9e62e4d7dc794618; });
$parcel$export(module.exports, "jsmBillingCycleConfig", function () { return $ff47f9ee8d194adc$export$34fbcdd33d5f7ba7; });
const $ff47f9ee8d194adc$export$be354061b07829a8 = 'MONTHLY';
const $ff47f9ee8d194adc$export$2295858875312a6f = 75;
const $ff47f9ee8d194adc$export$66d53803b4a2565a = 201;
const $ff47f9ee8d194adc$export$38631f866342776a = {
    free: 'jira-servicedesk-free',
    standard: 'jira-servicedesk-standard-repack-sku',
    premium: 'jira-servicedesk-premium',
    enterprise: 'jira-servicedesk-enterprise-sku'
};
const $ff47f9ee8d194adc$export$efd16829e921ffb8 = Object.values($ff47f9ee8d194adc$export$38631f866342776a);
const $ff47f9ee8d194adc$export$9e62e4d7dc794618 = [
    {
        planName: 'Free',
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: 'Standard',
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: 'Premium',
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: 'Enterprise',
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000
    }
];
const $ff47f9ee8d194adc$export$34fbcdd33d5f7ba7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("3fxcB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a077d34b75af68b5a629fa3ed5b43193>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25dc871355f8422b$var$_react = $25dc871355f8422b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $25dc871355f8422b$var$_baseNew = $25dc871355f8422b$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $25dc871355f8422b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25dc871355f8422b$var$LocationIcon = (props)=>/*#__PURE__*/ $25dc871355f8422b$var$_react.default.createElement($25dc871355f8422b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$25dc871355f8422b$var$LocationIcon.displayName = 'LocationIcon';
var $25dc871355f8422b$var$_default = module.exports.default = $25dc871355f8422b$var$LocationIcon;

});

parcelRegister("f5ck7", function(module, exports) {
$parcel$export(module.exports, "TabActiveContext", function () { return $4758c11da8236a1e$export$b48a823132043a33; });
$parcel$export(module.exports, "useTabActiveContext", function () { return $4758c11da8236a1e$export$f78195dad520baf6; });

var $1oC0p = parcelRequire("1oC0p");
const $4758c11da8236a1e$export$b48a823132043a33 = (0, $1oC0p.createContext)(true);
const $4758c11da8236a1e$export$f78195dad520baf6 = ()=>(0, $1oC0p.useContext)($4758c11da8236a1e$export$b48a823132043a33);

});

parcelRegister("60ByZ", function(module, exports) {
$parcel$export(module.exports, "Tab", function () { return $cac7b5f11fd9c462$export$3e41faf802a29e71; });
/* tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");
const $cac7b5f11fd9c462$var$listItemStyles = null;
const $cac7b5f11fd9c462$var$tabLinkStyles = null;
const $cac7b5f11fd9c462$var$inactiveTabStyles = null;
const $cac7b5f11fd9c462$var$playgroundTeamTabIds = new Set([
    'it-support',
    'it-operations',
    'engineering',
    'hr'
]);
const $cac7b5f11fd9c462$var$darkThemeInactiveTabStyles = null;
const $cac7b5f11fd9c462$var$activeTabStyles = null;
const $cac7b5f11fd9c462$var$darkThemeActiveTabStyles = null;
const $cac7b5f11fd9c462$var$largeTabSizingStyles = null;
const $cac7b5f11fd9c462$var$smallTabSizingStyles = null;
const $cac7b5f11fd9c462$export$3e41faf802a29e71 = ({ tabId: tabIdProp, index: index = 0, title: title, isActive: isActive = false, onTabSelect: onTabSelect, tabSize: tabSize, focusOnActivate: focusOnActivate = true })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const tabId = tabIdProp ?? `tab-${index}`;
    const tabLinkCustomStyles = {
        '--tab-hover-color': $cac7b5f11fd9c462$var$playgroundTeamTabIds.has(tabId) ? isDarkTheme ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.primary.black') : undefined
    };
    const tabRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = (0, $1oC0p.useCallback)((e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'tab',
            actionSubjectId: 'wacRefreshTab',
            source: 'tabsMenu',
            attributes: {
                label: title,
                tabId: tabId,
                tabIndex: index
            }
        }).fire();
        onTabSelect?.(tabId);
    }, [
        onTabSelect,
        tabId,
        title,
        index,
        createAnalyticsEvent
    ]);
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onTabSelect?.(tabId);
            return;
        }
        const currentTab = tabRef.current;
        const tabList = currentTab?.closest('[role="tablist"]');
        if (!tabList || !currentTab) return;
        const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        const currentIndex = tabs.indexOf(currentTab);
        if (currentIndex === -1) return;
        let nextIndex = null;
        switch(e.key){
            case 'ArrowRight':
                nextIndex = (currentIndex + 1) % tabs.length;
                break;
            case 'ArrowLeft':
                nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                break;
            case 'Home':
                nextIndex = 0;
                break;
            case 'End':
                nextIndex = tabs.length - 1;
                break;
            default:
                return;
        }
        e.preventDefault();
        tabs[nextIndex]?.click();
    }, [
        onTabSelect,
        tabId
    ]);
    // Track previous active state to only focus on changes, not initial mount
    const wasActive = (0, $1oC0p.useRef)(isActive);
    (0, $1oC0p.useEffect)(()=>{
        if (isActive && !wasActive.current && focusOnActivate && tabRef.current) tabRef.current.focus();
        wasActive.current = isActive;
    }, [
        isActive,
        focusOnActivate
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        "data-tab-id": tabId,
        role: "presentation",
        className: (0, $2jatx.default)([
            "_kqswh2mm _1pbykb7n _1hu1v2br _1e0c1txw _qtt8glyw _80omtlke"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            ref: tabRef,
            href: `#${tabId}`,
            role: "tab",
            id: `tab-${tabId}`,
            "aria-controls": tabId,
            "aria-selected": isActive,
            tabIndex: isActive ? 0 : -1,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            // Disable the browser's built-in link-drag behavior. Without
            // this, mousedown + small movement on the anchor fires
            // `dragstart` instead of `click`, silently swallowing the
            // tab selection.
            draggable: false,
            onDragStart: (e)=>e.preventDefault(),
            "data-event-container": "tab",
            "data-event-id": tabId,
            "data-event-label": title,
            className: (0, $2jatx.default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o _1rjcu2gc _o5721q9c _2rko1mv1 _4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke _v564cpn1 _12ji1r31 _1qu2glyw _12y31o36 _uiztglyw _1mymglyw _sedtglyw _k48pbfng",
                tabSize === 'large' && "_1wybf6fq _vwz41ou6 _18zr1ejb _3p1cgktf _py5o1f4h _owpuxy5q _fz891tcg _1ol9zwfg _ecdx1jfw",
                tabSize === 'small' && "_1wyb7vkz _vwz41tcg _18zrv47k _owpu1f4h _fz89f6fq _1ol91ou6 _ecdxxy5q",
                isActive ? isDarkTheme ? "_syaz1pfd _9h8h1pfd _10531pfd _1j301afi _1ygb6lb8 _1ah3myb0" : "_syaz1afi _9h8h1afi _10531afi _1j301pfd _1ygb14ak _1ah3myb0" : isDarkTheme ? "_syaz1afi _1j307ga5 _1ygb14ak _1ah312gs _o7ksglyw _30l31vvs _9h8h1vvs _10531afi" : "_syaz1pfd _1j30dkka _1ygb6lb8 _1ah312gs _o7ksglyw _30l313v2 _9h8h13v2 _10531pfd"
            ]),
            style: {
                ...tabLinkCustomStyles,
                "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400')),
                "--_138yw56": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue300')),
                "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: title
        })
    });
};

});

parcelRegister("lDmb2", function(module, exports) {
$parcel$export(module.exports, "TabList", function () { return $121910c2e808e15b$export$e51a686c67fdaa2d; });
/* tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $28sf5 = parcelRequire("28sf5");
const $121910c2e808e15b$var$tabListStyles = null;
const $121910c2e808e15b$var$highlightStyles = null;
const $121910c2e808e15b$var$darkThemeHighlightStyles = null;
const $121910c2e808e15b$var$tabListContainerStyles = null;
const $121910c2e808e15b$var$darkThemeTabListContainerStyles = null;
const $121910c2e808e15b$var$awf1TabListContainerStyles = null;
const $121910c2e808e15b$var$scrollAreaStyles = null;
const $121910c2e808e15b$var$navButtonStyles = null;
const $121910c2e808e15b$var$darkThemeNavButtonStyles = null;
const $121910c2e808e15b$var$hiddenNavButtonStyles = null;
const $121910c2e808e15b$var$fadeBaseStyles = null;
const $121910c2e808e15b$var$fadeStartStyles = null;
const $121910c2e808e15b$var$fadeEndStyles = null;
const $121910c2e808e15b$var$darkThemeFadeStartStyles = null;
const $121910c2e808e15b$var$darkThemeFadeEndStyles = null;
const $121910c2e808e15b$var$hiddenFadeStyles = null;
const $121910c2e808e15b$export$e51a686c67fdaa2d = ({ children: children, activeTabId: activeTabId })=>{
    const intl = (0, $8e22h.default)();
    const { isDarkTheme: isDarkTheme, isAwf1Theme: isAwf1Theme } = (0, $eOIix.useTheme)();
    const { scrollableRef: scrollableRef, highlightRef: highlightRef, isPreviousInactive: isPreviousInactive, isNextInactive: isNextInactive, handleScroll: handleScroll } = (0, $28sf5.useScrollableTabList)(activeTabId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScrollLeft = (0, $1oC0p.useCallback)(()=>{
        handleScroll(-1);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'scrollTabsLeft',
            source: 'tabScrollControl',
            attributes: {
                label: 'scroll tabs left'
            }
        }).fire();
    }, [
        handleScroll,
        createAnalyticsEvent
    ]);
    const handleScrollRight = (0, $1oC0p.useCallback)(()=>{
        handleScroll(1);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'scrollTabsRight',
            source: 'tabScrollControl',
            attributes: {
                label: 'scroll tabs right'
            }
        }).fire();
    }, [
        handleScroll,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _11q7dkka _1j301j28 _2rko1jfw _1yt4u2gc _1bsb1ns9 _p12f1osq",
            isDarkTheme && "_11q7vkha _z21jtf30",
            isAwf1Theme && "_1p1dangw _ect4zzfg"
        ]),
        style: {
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
            "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200')),
            "--_vimidu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark600'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleScrollLeft,
                "aria-label": intl.formatMessage({
                    id: 'tab-list.scroll-left',
                    defaultMessage: 'Scroll tabs left'
                }),
                tabIndex: isPreviousInactive ? -1 : 0,
                "aria-hidden": isPreviousInactive,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19itglyw _80omtlke _1yt4119w _1ul91ejb _1tke1ejb _syaz1pfd _1o9zidpf _tzy4kb7n _v5641hrg _sugaglyw",
                    isDarkTheme && "_syaz1afi",
                    isPreviousInactive && "_tzy4idpf _lcxvglyw _1bsbidpf _1ul9idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "7",
                    height: "12",
                    viewBox: "0 0 7 12",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M5.8335 10.8333L0.833496 5.83334L5.8335 0.833344",
                        stroke: isDarkTheme ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.primary.black'),
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _u7coidpf _1bsb1ejb _lcxvglyw _1pbycs5v _v5641hrg",
                            "_1e02idpf _11q7dx5r",
                            isDarkTheme && "_11q71ta9",
                            isPreviousInactive && "_tzy4idpf"
                        ]),
                        style: {
                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                            "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                        ref: scrollableRef,
                        role: "tablist",
                        "aria-orientation": "horizontal",
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e0c1txw _4cvr1h6o _1bsb1osq _1reo15zi _rjfvx6dd _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kpfhglyw _8164u2gc _1uvfzwfg _1wwwzwfg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                ref: highlightRef,
                                "aria-hidden": "true",
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152tidpf _4t3i1osq _2rkoxy5q _11q71pfd _sugaglyw _v5641r0g _lcxvglyw _sedtglyw",
                                    isDarkTheme && "_11q71afi"
                                ]),
                                style: {
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                }
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _u7coidpf _1bsb1ejb _lcxvglyw _1pbycs5v _v5641hrg",
                            "_rjxpidpf _11q7ugqf",
                            isDarkTheme && "_11q717kn",
                            isNextInactive && "_tzy4idpf"
                        ]),
                        style: {
                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                            "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleScrollRight,
                "aria-label": intl.formatMessage({
                    id: 'tab-list.scroll-right',
                    defaultMessage: 'Scroll tabs right'
                }),
                tabIndex: isNextInactive ? -1 : 0,
                "aria-hidden": isNextInactive,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19itglyw _80omtlke _1yt4119w _1ul91ejb _1tke1ejb _syaz1pfd _1o9zidpf _tzy4kb7n _v5641hrg _sugaglyw",
                    isDarkTheme && "_syaz1afi",
                    isNextInactive && "_tzy4idpf _lcxvglyw _1bsbidpf _1ul9idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "7",
                    height: "12",
                    viewBox: "0 0 7 12",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0.833496 10.8333L5.8335 5.83334L0.833496 0.833344",
                        stroke: isDarkTheme ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.primary.black'),
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            })
        ]
    });
};

});
parcelRegister("28sf5", function(module, exports) {
$parcel$export(module.exports, "useScrollableTabList", function () { return $ef69e28b94f66947$export$370d3ad9e0600bac; });

var $1oC0p = parcelRequire("1oC0p");
const $ef69e28b94f66947$var$SCROLL_AMOUNT = 200;
const $ef69e28b94f66947$var$SCROLL_PADDING = 48;
const $ef69e28b94f66947$var$prefersReducedMotion = ()=>typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $ef69e28b94f66947$export$370d3ad9e0600bac = (activeTabId)=>{
    const scrollableRef = (0, $1oC0p.useRef)(null);
    const highlightRef = (0, $1oC0p.useRef)(null);
    const [isPreviousInactive, setIsPreviousInactive] = (0, $1oC0p.useState)(true);
    const [isNextInactive, setIsNextInactive] = (0, $1oC0p.useState)(true);
    const isFirstRender = (0, $1oC0p.useRef)(true);
    const isManualScrolling = (0, $1oC0p.useRef)(false);
    const isProgrammaticScroll = (0, $1oC0p.useRef)(false);
    const manualScrollTimeoutRef = (0, $1oC0p.useRef)();
    // Suppress auto-centering for a duration after manual scrolling
    const markManualScroll = (0, $1oC0p.useCallback)(()=>{
        isManualScrolling.current = true;
        if (manualScrollTimeoutRef.current) clearTimeout(manualScrollTimeoutRef.current);
        manualScrollTimeoutRef.current = setTimeout(()=>{
            isManualScrolling.current = false;
        }, 500);
    }, []);
    // Measure and position the highlight behind the active tab
    const updateHighlightPosition = (0, $1oC0p.useCallback)(()=>{
        const scrollable = scrollableRef.current;
        const highlight = highlightRef.current;
        if (!scrollable || !highlight || !activeTabId) return;
        const activeTab = scrollable.querySelector(`[data-tab-id="${activeTabId}"]`);
        if (!activeTab) return;
        const listRect = scrollable.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();
        const left = tabRect.left - listRect.left + scrollable.scrollLeft;
        const width = tabRect.width;
        highlight.style.left = `${left}px`;
        highlight.style.width = `${width}px`;
    }, [
        activeTabId
    ]);
    // Scroll the active tab into the center of the visible area
    const scrollActiveTabIntoView = (0, $1oC0p.useCallback)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable || !activeTabId) return;
        const activeTab = scrollable.querySelector(`[data-tab-id="${activeTabId}"]`);
        if (!activeTab) return;
        const scrollableWidth = scrollable.offsetWidth;
        const tabLeft = activeTab.offsetLeft;
        const tabWidth = activeTab.offsetWidth;
        const targetScroll = tabLeft - (scrollableWidth - tabWidth) / 2;
        isProgrammaticScroll.current = true;
        scrollable.scrollTo({
            left: targetScroll,
            behavior: $ef69e28b94f66947$var$prefersReducedMotion() ? 'auto' : 'smooth'
        });
    }, [
        activeTabId
    ]);
    // Update nav button visibility based on scroll position
    const updateNavButtonVisibility = (0, $1oC0p.useCallback)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable) return;
        const atEnd = scrollable.scrollLeft > scrollable.scrollWidth - scrollable.offsetWidth - $ef69e28b94f66947$var$SCROLL_PADDING * 0.75;
        const atStart = scrollable.scrollLeft <= $ef69e28b94f66947$var$SCROLL_PADDING;
        setIsNextInactive(atEnd);
        setIsPreviousInactive(atStart);
    }, []);
    // Scroll the tab list by a fixed amount
    const handleScroll = (0, $1oC0p.useCallback)((direction)=>{
        const scrollable = scrollableRef.current;
        if (!scrollable) return;
        markManualScroll();
        isProgrammaticScroll.current = true;
        scrollable.scrollTo({
            top: 0,
            left: scrollable.scrollLeft + $ef69e28b94f66947$var$SCROLL_AMOUNT * direction,
            behavior: $ef69e28b94f66947$var$prefersReducedMotion() ? 'auto' : 'smooth'
        });
    }, [
        markManualScroll
    ]);
    // Position highlight on first render without transition
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (isFirstRender.current) {
            const highlight = highlightRef.current;
            if (highlight) highlight.style.transition = 'none';
            requestAnimationFrame(()=>{
                updateHighlightPosition();
                requestAnimationFrame(()=>{
                    if (highlight) highlight.style.transition = '';
                    isFirstRender.current = false;
                });
            });
        }
    }, [
        updateHighlightPosition
    ]);
    // Update highlight and scroll into view on subsequent tab changes
    (0, $1oC0p.useEffect)(()=>{
        if (!isFirstRender.current) {
            updateHighlightPosition();
            scrollActiveTabIntoView();
        }
    }, [
        updateHighlightPosition,
        scrollActiveTabIntoView
    ]);
    // Recalculate highlight position and scroll on container resize (debounced)
    (0, $1oC0p.useEffect)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable || typeof ResizeObserver !== 'function') return;
        let rafId = null;
        const observer = new ResizeObserver(()=>{
            if (rafId !== null) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(()=>{
                updateHighlightPosition();
                if (!isManualScrolling.current) scrollActiveTabIntoView();
                rafId = null;
            });
        });
        observer.observe(scrollable);
        return ()=>{
            if (rafId !== null) cancelAnimationFrame(rafId);
            if (manualScrollTimeoutRef.current) clearTimeout(manualScrollTimeoutRef.current);
            observer.disconnect();
        };
    }, [
        updateHighlightPosition,
        scrollActiveTabIntoView
    ]);
    // Detect manual (user-initiated) horizontal scrolling on the tab list
    (0, $1oC0p.useEffect)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable) return;
        const onScroll = ()=>{
            if (isProgrammaticScroll.current) {
                isProgrammaticScroll.current = false;
                return;
            }
            markManualScroll();
        };
        scrollable.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>{
            scrollable.removeEventListener('scroll', onScroll);
        };
    }, [
        markManualScroll
    ]);
    // Set up IntersectionObserver to track scroll position for nav buttons
    (0, $1oC0p.useEffect)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable || typeof window.IntersectionObserver !== 'function') return;
        const options = {
            root: scrollable,
            rootMargin: `0px ${$ef69e28b94f66947$var$SCROLL_PADDING * 0.75}px 0px 0px`,
            threshold: [
                0.1,
                0.9,
                1.0
            ]
        };
        const observer = new IntersectionObserver(()=>{
            updateNavButtonVisibility();
        }, options);
        const firstItem = scrollable.querySelector('li:first-of-type');
        const lastItem = scrollable.querySelector('li:last-of-type');
        if (firstItem) observer.observe(firstItem);
        if (lastItem) observer.observe(lastItem);
        updateNavButtonVisibility();
        return ()=>{
            observer.disconnect();
        };
    }, [
        updateNavButtonVisibility
    ]);
    return {
        scrollableRef: scrollableRef,
        highlightRef: highlightRef,
        isPreviousInactive: isPreviousInactive,
        isNextInactive: isNextInactive,
        handleScroll: handleScroll
    };
};

});


parcelRegister("1dc5i", function(module, exports) {
$parcel$export(module.exports, "TabPanel", function () { return $fb7ea0e2b2e15ff6$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $f5ck7 = parcelRequire("f5ck7");
// All panels are kept in the DOM and stacked in the same CSS grid cell so we can
// cross-fade between them without any layout shift. This matches the canonical
// WAC stacked-cross-fade idiom used in `customer-testimonials` and
// `hero-carousel` (gridArea "1 / 1" + opacity transition). Spec: GWP-11578.
const $fb7ea0e2b2e15ff6$var$panelStyles = null;
const $fb7ea0e2b2e15ff6$var$activePanelStyles = null;
const $fb7ea0e2b2e15ff6$export$3d96ec278d3efce4 = ({ children: children, id: id, isActive: isActive = true, ...rest })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f5ck7.TabActiveContext).Provider, {
        value: isActive,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            id: id,
            role: "tabpanel",
            "aria-labelledby": `tab-${id}`,
            // Inactive panels are visually invisible (opacity 0) and not
            // interactive (pointer-events: none + tabIndex: -1). They still
            // exist in the accessibility tree so screen readers can navigate,
            // but `aria-hidden` keeps them out of the announcement queue.
            tabIndex: isActive ? 0 : -1,
            "aria-hidden": !isActive,
            ...rest,
            className: (0, $2jatx.default)([
                "_nd5l1ekt _tzy4idpf _lcxvglyw _v56412jn _sedtglyw",
                isActive && "_tzy4kb7n _lcxv1wug"
            ]),
            style: {
                "--_1mnvk9u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.400ms')),
                "--_kqkuu4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-in-out'))
            },
            children: children
        })
    });
};

});

parcelRegister("leEwa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f75e2054943fb775b789c9f2b57e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f75a55c8f3683e3c$var$_react = $f75a55c8f3683e3c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f75a55c8f3683e3c$var$_baseNew = $f75a55c8f3683e3c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f75a55c8f3683e3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f75a55c8f3683e3c$var$ChartBarIcon = (props)=>/*#__PURE__*/ $f75a55c8f3683e3c$var$_react.default.createElement($f75a55c8f3683e3c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$f75a55c8f3683e3c$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $f75a55c8f3683e3c$var$_default = module.exports.default = $f75a55c8f3683e3c$var$ChartBarIcon;

});

parcelRegister("agxCc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21c7c38467d82a38f61fac3c4f24f045>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77957947befae1d2$var$_react = $77957947befae1d2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $77957947befae1d2$var$_baseNew = $77957947befae1d2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $77957947befae1d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77957947befae1d2$var$AiChatIcon = (props)=>/*#__PURE__*/ $77957947befae1d2$var$_react.default.createElement($77957947befae1d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$77957947befae1d2$var$AiChatIcon.displayName = 'AiChatIcon';
var $77957947befae1d2$var$_default = module.exports.default = $77957947befae1d2$var$AiChatIcon;

});

parcelRegister("gyofT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec2830ef4a5653740a2b8f60e21924b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0d2a2eb698c43d8$var$_react = $c0d2a2eb698c43d8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c0d2a2eb698c43d8$var$_baseNew = $c0d2a2eb698c43d8$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $c0d2a2eb698c43d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0d2a2eb698c43d8$var$AiAgentIcon = (props)=>/*#__PURE__*/ $c0d2a2eb698c43d8$var$_react.default.createElement($c0d2a2eb698c43d8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$c0d2a2eb698c43d8$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $c0d2a2eb698c43d8$var$_default = module.exports.default = $c0d2a2eb698c43d8$var$AiAgentIcon;

});

parcelRegister("ktqe1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee7adbdfec1a4e3f$var$_react = $ee7adbdfec1a4e3f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ee7adbdfec1a4e3f$var$_baseNew = $ee7adbdfec1a4e3f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $ee7adbdfec1a4e3f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee7adbdfec1a4e3f$var$BugIcon = (props)=>/*#__PURE__*/ $ee7adbdfec1a4e3f$var$_react.default.createElement($ee7adbdfec1a4e3f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$ee7adbdfec1a4e3f$var$BugIcon.displayName = 'BugIcon';
var $ee7adbdfec1a4e3f$var$_default = module.exports.default = $ee7adbdfec1a4e3f$var$BugIcon;

});

parcelRegister("cybEc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::adfa31acacdadf9066a8b0b559629bfc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9231b1ecc601cac2$var$_react = $9231b1ecc601cac2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9231b1ecc601cac2$var$_baseNew = $9231b1ecc601cac2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $9231b1ecc601cac2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9231b1ecc601cac2$var$ClockIcon = (props)=>/*#__PURE__*/ $9231b1ecc601cac2$var$_react.default.createElement($9231b1ecc601cac2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$9231b1ecc601cac2$var$ClockIcon.displayName = 'ClockIcon';
var $9231b1ecc601cac2$var$_default = module.exports.default = $9231b1ecc601cac2$var$ClockIcon;

});

parcelRegister("iCsNc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8e21c38448f35d8$var$_react = $d8e21c38448f35d8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d8e21c38448f35d8$var$_baseNew = $d8e21c38448f35d8$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $d8e21c38448f35d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8e21c38448f35d8$var$AutomationIcon = (props)=>/*#__PURE__*/ $d8e21c38448f35d8$var$_react.default.createElement($d8e21c38448f35d8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$d8e21c38448f35d8$var$AutomationIcon.displayName = 'AutomationIcon';
var $d8e21c38448f35d8$var$_default = module.exports.default = $d8e21c38448f35d8$var$AutomationIcon;

});

parcelRegister("dNI7u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0c2133a3d226096$var$_react = $a0c2133a3d226096$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a0c2133a3d226096$var$_baseNew = $a0c2133a3d226096$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a0c2133a3d226096$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0c2133a3d226096$var$BranchIcon = (props)=>/*#__PURE__*/ $a0c2133a3d226096$var$_react.default.createElement($a0c2133a3d226096$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$a0c2133a3d226096$var$BranchIcon.displayName = 'BranchIcon';
var $a0c2133a3d226096$var$_default = module.exports.default = $a0c2133a3d226096$var$BranchIcon;

});

parcelRegister("g02sa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccb1509d7e2270e6a953aebace8cfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba5e8c96d5d39b0c$var$_react = $ba5e8c96d5d39b0c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ba5e8c96d5d39b0c$var$_baseNew = $ba5e8c96d5d39b0c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $ba5e8c96d5d39b0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba5e8c96d5d39b0c$var$ShareIcon = (props)=>/*#__PURE__*/ $ba5e8c96d5d39b0c$var$_react.default.createElement($ba5e8c96d5d39b0c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$ba5e8c96d5d39b0c$var$ShareIcon.displayName = 'ShareIcon';
var $ba5e8c96d5d39b0c$var$_default = module.exports.default = $ba5e8c96d5d39b0c$var$ShareIcon;

});

parcelRegister("5EeVR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66345548d441cf68$export$2e2bcd8739ae039; });
/* skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");
const $66345548d441cf68$var$DEFAULT_LINE_HEIGHT = '1.25rem';
const $66345548d441cf68$var$DEFAULT_WIDTH = '100%';
const $66345548d441cf68$var$DEFAULT_MAX_WIDTH = '100%';
const $66345548d441cf68$var$DEFAULT_GAP = '150';
const $66345548d441cf68$var$DEFAULT_COUNT = 1;
const $66345548d441cf68$var$ALIGN_TO_FLEX = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    stretch: 'stretch'
};
// Breakpoint rules read CSS custom properties so the static `css` stays
// build-time-extractable while per-bone values are supplied inline.
const $66345548d441cf68$var$containerStyles = null;
const $66345548d441cf68$var$boneStyles = null;
// Uniform sends "" (not undefined) for an unset field; treat both as "no value".
const $66345548d441cf68$var$orFallback = (value, fallback)=>value === undefined || value === '' ? fallback : value;
const $66345548d441cf68$var$toCount = (value)=>{
    if (value === undefined || value === '') return undefined;
    const numeric = typeof value === 'string' ? Number(value) : value;
    return Number.isFinite(numeric) && numeric > 0 ? Math.floor(numeric) : undefined;
};
const $66345548d441cf68$var$resolveFlatCount = (mobile, tablet, desktop)=>{
    const mobileValue = $66345548d441cf68$var$toCount(mobile) ?? $66345548d441cf68$var$DEFAULT_COUNT;
    const tabletValue = $66345548d441cf68$var$toCount(tablet) ?? mobileValue;
    const desktopValue = $66345548d441cf68$var$toCount(desktop) ?? tabletValue;
    return {
        mobile: mobileValue,
        tablet: tabletValue,
        desktop: desktopValue
    };
};
// Cascades unset breakpoints up from mobile.
const $66345548d441cf68$var$resolveFlat = (mobile, tablet, desktop, fallback)=>{
    const mobileValue = $66345548d441cf68$var$orFallback(mobile, fallback);
    const tabletValue = $66345548d441cf68$var$orFallback(tablet, mobileValue);
    const desktopValue = $66345548d441cf68$var$orFallback(desktop, tabletValue);
    return {
        mobile: mobileValue,
        tablet: tabletValue,
        desktop: desktopValue
    };
};
// Tolerates a partial object (Uniform may only author the mobile value).
const $66345548d441cf68$var$resolveGap = (gap)=>{
    const value = gap ?? {};
    const mobile = $66345548d441cf68$var$orFallback(value.mobile, $66345548d441cf68$var$DEFAULT_GAP);
    const tablet = $66345548d441cf68$var$orFallback(value.tablet, mobile);
    const desktop = $66345548d441cf68$var$orFallback(value.desktop, tablet);
    return {
        mobile: `var(--ds-space-${mobile})`,
        tablet: `var(--ds-space-${tablet})`,
        desktop: `var(--ds-space-${desktop})`
    };
};
const $66345548d441cf68$var$UniformSkeleton = ({ width: width, tabletWidth: tabletWidth, desktopWidth: desktopWidth, maxWidth: maxWidth, tabletMaxWidth: tabletMaxWidth, desktopMaxWidth: desktopMaxWidth, height: height, tabletHeight: tabletHeight, desktopHeight: desktopHeight, aspectRatio: aspectRatio, tabletAspectRatio: tabletAspectRatio, desktopAspectRatio: desktopAspectRatio, borderRadius: borderRadius, count: count, tabletCount: tabletCount, desktopCount: desktopCount, gap: gap, lastLineWidth: lastLineWidth, tabletLastLineWidth: tabletLastLineWidth, desktopLastLineWidth: desktopLastLineWidth, align: align = 'stretch' })=>{
    const counts = $66345548d441cf68$var$resolveFlatCount(count, tabletCount, desktopCount);
    const maxCount = Math.max(counts.mobile, counts.tablet, counts.desktop);
    const widths = $66345548d441cf68$var$resolveFlat(width, tabletWidth, desktopWidth, $66345548d441cf68$var$DEFAULT_WIDTH);
    const maxWidths = $66345548d441cf68$var$resolveFlat(maxWidth, tabletMaxWidth, desktopMaxWidth, $66345548d441cf68$var$DEFAULT_MAX_WIDTH);
    // "" means "no override": fall back to the normal width / no aspect ratio.
    const lastWidths = $66345548d441cf68$var$resolveFlat(lastLineWidth, tabletLastLineWidth, desktopLastLineWidth, '');
    const aspectRatios = $66345548d441cf68$var$resolveFlat(aspectRatio, tabletAspectRatio, desktopAspectRatio, '');
    const heights = $66345548d441cf68$var$resolveFlat(height, tabletHeight, desktopHeight, $66345548d441cf68$var$DEFAULT_LINE_HEIGHT);
    const gaps = $66345548d441cf68$var$resolveGap(gap);
    // Where an aspectRatio is set the height is `auto`; otherwise the fixed one.
    const heightAt = (viewport)=>aspectRatios[viewport] ? 'auto' : heights[viewport];
    const aspectAt = (viewport)=>aspectRatios[viewport] || 'auto';
    const containerStyle = {
        '--wac-skeleton-gap-mobile': gaps.mobile,
        '--wac-skeleton-gap-tablet': gaps.tablet,
        '--wac-skeleton-gap-desktop': gaps.desktop,
        alignItems: $66345548d441cf68$var$ALIGN_TO_FLEX[align]
    };
    // The last visible bone gets the short last-line width, when one is set.
    const widthAt = (index, viewport)=>{
        const isLastVisible = counts[viewport] > 1 && index === counts[viewport] - 1;
        return isLastVisible && lastWidths[viewport] ? lastWidths[viewport] : widths[viewport];
    };
    const displayAt = (index, viewport)=>index < counts[viewport] ? 'block' : 'none';
    const buildBoneStyle = (index)=>({
            '--wac-skeleton-display-mobile': displayAt(index, 'mobile'),
            '--wac-skeleton-display-tablet': displayAt(index, 'tablet'),
            '--wac-skeleton-display-desktop': displayAt(index, 'desktop'),
            '--wac-skeleton-width-mobile': widthAt(index, 'mobile'),
            '--wac-skeleton-width-tablet': widthAt(index, 'tablet'),
            '--wac-skeleton-width-desktop': widthAt(index, 'desktop'),
            '--wac-skeleton-max-width-mobile': maxWidths.mobile,
            '--wac-skeleton-max-width-tablet': maxWidths.tablet,
            '--wac-skeleton-max-width-desktop': maxWidths.desktop,
            '--wac-skeleton-height-mobile': heightAt('mobile'),
            '--wac-skeleton-height-tablet': heightAt('tablet'),
            '--wac-skeleton-height-desktop': heightAt('desktop'),
            '--wac-skeleton-aspect-mobile': aspectAt('mobile'),
            '--wac-skeleton-aspect-tablet': aspectAt('tablet'),
            '--wac-skeleton-aspect-desktop': aspectAt('desktop'),
            borderRadius: borderRadius
        });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: containerStyle,
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _1p57xte4 _1to91dlp _1plr1sr7"
        ]),
        children: Array.from({
            length: maxCount
        }, (_, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: buildBoneStyle(index),
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1reo15vq _18m915vq _1e0cnw9a _1bsb1pk8 _p12f1o5e _4t3izf1f _1h1t1fty _181n19o1 _14b514g9 _b8yq1l85 _1xlo1qh7 _7dyz1vvd _dm25suzz _glte1j0o _10jx7cob _165tmmre _bb4111mi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "100%",
                    height: "100%"
                })
            }, index))
    });
};
var $66345548d441cf68$export$2e2bcd8739ae039 = $66345548d441cf68$var$UniformSkeleton;

});

parcelRegister("f3oWf", function(module, exports) {
$parcel$export(module.exports, "iconMapping", function () { return $e4f57aa48d72479d$export$82f701de2810d5a7; });

var $gyofT = parcelRequire("gyofT");

var $agxCc = parcelRequire("agxCc");

var $8kWtd = parcelRequire("8kWtd");

var $6OwZZ = parcelRequire("6OwZZ");

var $4Vh86 = parcelRequire("4Vh86");

var $5qjmd = parcelRequire("5qjmd");

var $iCsNc = parcelRequire("iCsNc");

var $a7Xqx = parcelRequire("a7Xqx");

var $97j0t = parcelRequire("97j0t");

var $aVTcD = parcelRequire("aVTcD");

var $dNI7u = parcelRequire("dNI7u");

var $l4wQM = parcelRequire("l4wQM");

var $ktqe1 = parcelRequire("ktqe1");

var $56bcs = parcelRequire("56bcs");

var $5II9n = parcelRequire("5II9n");

var $1LeRj = parcelRequire("1LeRj");

var $leEwa = parcelRequire("leEwa");

var $era0o = parcelRequire("era0o");

var $iZu54 = parcelRequire("iZu54");

var $loQfN = parcelRequire("loQfN");

var $hrBjL = parcelRequire("hrBjL");

var $61pdb = parcelRequire("61pdb");

var $7ilxc = parcelRequire("7ilxc");

var $cybEc = parcelRequire("cybEc");

var $fhgNY = parcelRequire("fhgNY");

var $6e3tU = parcelRequire("6e3tU");

var $9ghqh = parcelRequire("9ghqh");

var $dO8Do = parcelRequire("dO8Do");

var $3FUL0 = parcelRequire("3FUL0");

var $3OOxO = parcelRequire("3OOxO");

var $2JPM3 = parcelRequire("2JPM3");

var $6pmKv = parcelRequire("6pmKv");

var $6j91P = parcelRequire("6j91P");

var $iSCOr = parcelRequire("iSCOr");

var $2RA08 = parcelRequire("2RA08");

var $9A47Z = parcelRequire("9A47Z");

var $biJi9 = parcelRequire("biJi9");

var $3AJLg = parcelRequire("3AJLg");

var $6UXAj = parcelRequire("6UXAj");

var $dNlyT = parcelRequire("dNlyT");

var $49zFb = parcelRequire("49zFb");

var $cNamI = parcelRequire("cNamI");

var $eAAXu = parcelRequire("eAAXu");

var $gta0F = parcelRequire("gta0F");

var $fonh7 = parcelRequire("fonh7");

var $3fxcB = parcelRequire("3fxcB");

var $ck1qR = parcelRequire("ck1qR");

var $iBtIB = parcelRequire("iBtIB");

var $cOWmd = parcelRequire("cOWmd");

var $ax2O9 = parcelRequire("ax2O9");

var $kX9u3 = parcelRequire("kX9u3");

var $hz0ya = parcelRequire("hz0ya");

var $bECX9 = parcelRequire("bECX9");

var $5SjQD = parcelRequire("5SjQD");

var $6hGO6 = parcelRequire("6hGO6");

var $l23yj = parcelRequire("l23yj");

var $czSoI = parcelRequire("czSoI");

var $kvde0 = parcelRequire("kvde0");

var $7V9HC = parcelRequire("7V9HC");

var $7Xn5M = parcelRequire("7Xn5M");

var $hA8Qq = parcelRequire("hA8Qq");

var $hBIcK = parcelRequire("hBIcK");

var $7doBf = parcelRequire("7doBf");

var $gHoFv = parcelRequire("gHoFv");

var $qz5Fw = parcelRequire("qz5Fw");

var $5ZCzy = parcelRequire("5ZCzy");

var $g02sa = parcelRequire("g02sa");

var $3w1ji = parcelRequire("3w1ji");

var $fq25Q = parcelRequire("fq25Q");

var $2Qv7t = parcelRequire("2Qv7t");

var $48PMv = parcelRequire("48PMv");

var $8GlZZ = parcelRequire("8GlZZ");

var $5R44a = parcelRequire("5R44a");

var $aUEBX = parcelRequire("aUEBX");

var $9ih0P = parcelRequire("9ih0P");

var $1DU5m = parcelRequire("1DU5m");

var $djIg7 = parcelRequire("djIg7");

var $l7rtf = parcelRequire("l7rtf");

var $1eGzb = parcelRequire("1eGzb");

var $k2zyM = parcelRequire("k2zyM");

var $2GO8b = parcelRequire("2GO8b");

var $dTPlE = parcelRequire("dTPlE");

var $8BlKa = parcelRequire("8BlKa");

var $lUMmm = parcelRequire("lUMmm");

var $6xXDI = parcelRequire("6xXDI");

var $f1MsQ = parcelRequire("f1MsQ");

var $5nJnO = parcelRequire("5nJnO");
const $e4f57aa48d72479d$export$82f701de2810d5a7 = {
    AiGenerativeTextSummaryIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8kWtd))),
        version: 'core'
    },
    AssetsGraphIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1eGzb))),
        version: 'core'
    },
    ClockIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cybEc))),
        version: 'core'
    },
    RovoIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lUMmm))),
        version: 'core'
    },
    TextAudioTranscriptIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($f1MsQ))),
        version: 'core'
    },
    TimelineIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aUEBX))),
        version: 'core'
    },
    CalendarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($56bcs))),
        version: 'core'
    },
    CameraIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5II9n))),
        version: 'core'
    },
    WarningIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($djIg7))),
        version: 'core'
    },
    TeamsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5R44a))),
        version: 'core'
    },
    ChangesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1LeRj))),
        version: 'core'
    },
    ChartBarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($leEwa))),
        version: 'core'
    },
    BriefcaseIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($l4wQM))),
        version: 'core'
    },
    AutomationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iCsNc))),
        version: 'core'
    },
    BugIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ktqe1))),
        version: 'core'
    },
    DepartmentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3FUL0))),
        version: 'core'
    },
    EyeOpenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6pmKv))),
        version: 'core'
    },
    BranchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dNI7u))),
        version: 'core'
    },
    PhoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7V9HC))),
        version: 'core'
    },
    PremiumIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7Xn5M))),
        version: 'core'
    },
    CommentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6e3tU))),
        version: 'core'
    },
    Page: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bECX9))),
        version: 'core'
    },
    PageIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bECX9))),
        version: 'core'
    },
    PersonAddIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($czSoI))),
        version: 'core'
    },
    PersonAddedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kvde0))),
        version: 'core'
    },
    LobbyBellIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fonh7))),
        version: 'core'
    },
    LocationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3fxcB))),
        version: 'core'
    },
    InformationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($49zFb))),
        version: 'core'
    },
    PriorityMajorIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hBIcK))),
        version: 'core'
    },
    OfficeBuildingIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kX9u3))),
        version: 'core'
    },
    ChartTrendIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($loQfN))),
        version: 'core'
    },
    CheckboxCheckedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7ilxc))),
        version: 'core'
    },
    GoalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6UXAj))),
        version: 'core'
    },
    ScreenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($qz5Fw))),
        version: 'core'
    },
    BookWithBookmarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aVTcD))),
        version: 'core'
    },
    PagesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5SjQD))),
        version: 'core'
    },
    ChartMatrixIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iZu54))),
        version: 'core'
    },
    RoadmapIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gHoFv))),
        version: 'core'
    },
    ShowMoreVerticalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3w1ji))),
        version: 'core'
    },
    TagIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($48PMv))),
        version: 'core'
    },
    MarketplaceIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iBtIB))),
        version: 'core'
    },
    AngleBracketsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4Vh86))),
        version: 'core'
    },
    ProjectIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7doBf))),
        version: 'core'
    },
    BoardIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($97j0t))),
        version: 'core'
    },
    MegaphoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cOWmd))),
        version: 'core'
    },
    TransitionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9ih0P))),
        version: 'core'
    },
    VideoIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1DU5m))),
        version: 'core'
    },
    StarStarredIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2Qv7t))),
        version: 'core'
    },
    EmojiIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2JPM3))),
        version: 'core'
    },
    TaskInProgressIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8GlZZ))),
        version: 'core'
    },
    FormsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3AJLg))),
        version: 'core'
    },
    FilesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9A47Z))),
        version: 'core'
    },
    FlagIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($biJi9))),
        version: 'core'
    },
    FileIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2RA08))),
        version: 'core'
    },
    ListBulletedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eAAXu))),
        version: 'core'
    },
    SmartLinkListIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fq25Q))),
        version: 'core'
    },
    MagicWandIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ck1qR))),
        version: 'core'
    },
    OperationsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hz0ya))),
        version: 'core'
    },
    DecisionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dO8Do))),
        version: 'core'
    },
    FeedbackIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6j91P))),
        version: 'core'
    },
    ObjectiveIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ax2O9))),
        version: 'core'
    },
    PresenterModeIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hA8Qq))),
        version: 'core'
    },
    BacklogIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($a7Xqx))),
        version: 'core'
    },
    SearchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5ZCzy))),
        version: 'core'
    },
    EditIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3OOxO))),
        version: 'core'
    },
    CheckMarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($61pdb))),
        version: 'core'
    },
    CheckCircleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))),
        version: 'core'
    },
    ListChecklistIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gta0F))),
        version: 'core'
    },
    ArchiveBoxIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5qjmd))),
        version: 'core'
    },
    AlertIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6OwZZ))),
        version: 'core'
    },
    RoadmapsPlanIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8BlKa))),
        version: 'core'
    },
    PeopleGroupIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6hGO6))),
        version: 'core'
    },
    BrowserExtensionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($k2zyM))),
        version: 'core'
    },
    SyncIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6xXDI))),
        version: 'core'
    },
    NotepadIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2GO8b))),
        version: 'core'
    },
    PageLiveDocIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dTPlE))),
        version: 'core'
    },
    AiAgentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gyofT))),
        version: 'core'
    },
    AiChatIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($agxCc))),
        version: 'core'
    },
    ChartBubbleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($era0o))),
        version: 'core'
    },
    CloudArrowUpIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fhgNY))),
        version: 'core'
    },
    DataFlowIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9ghqh))),
        version: 'core'
    },
    FieldCheckboxGroupIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iSCOr))),
        version: 'core'
    },
    GridIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dNlyT))),
        version: 'core'
    },
    LightbulbIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cNamI))),
        version: 'core'
    },
    PersonIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($l23yj))),
        version: 'core'
    },
    ShareIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($g02sa))),
        version: 'core'
    },
    WorkItemsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($l7rtf))),
        version: 'core'
    },
    ViewsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5nJnO))),
        version: 'core'
    }
};

});
parcelRegister("6OwZZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6102723708b1ca$var$_react = $4f6102723708b1ca$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4f6102723708b1ca$var$_baseNew = $4f6102723708b1ca$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4f6102723708b1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f6102723708b1ca$var$AlertIcon = (props)=>/*#__PURE__*/ $4f6102723708b1ca$var$_react.default.createElement($4f6102723708b1ca$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$4f6102723708b1ca$var$AlertIcon.displayName = 'AlertIcon';
var $4f6102723708b1ca$var$_default = module.exports.default = $4f6102723708b1ca$var$AlertIcon;

});

parcelRegister("4Vh86", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3959c5e36ea5e16d$var$_react = $3959c5e36ea5e16d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3959c5e36ea5e16d$var$_baseNew = $3959c5e36ea5e16d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3959c5e36ea5e16d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3959c5e36ea5e16d$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $3959c5e36ea5e16d$var$_react.default.createElement($3959c5e36ea5e16d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$3959c5e36ea5e16d$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $3959c5e36ea5e16d$var$_default = module.exports.default = $3959c5e36ea5e16d$var$AngleBracketsIcon;

});

parcelRegister("5qjmd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f2e65705ed861f0$var$_react = $3f2e65705ed861f0$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3f2e65705ed861f0$var$_baseNew = $3f2e65705ed861f0$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3f2e65705ed861f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f2e65705ed861f0$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $3f2e65705ed861f0$var$_react.default.createElement($3f2e65705ed861f0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$3f2e65705ed861f0$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $3f2e65705ed861f0$var$_default = module.exports.default = $3f2e65705ed861f0$var$ArchiveBoxIcon;

});

parcelRegister("l4wQM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f573741a4f66ef2e$var$_react = $f573741a4f66ef2e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f573741a4f66ef2e$var$_baseNew = $f573741a4f66ef2e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f573741a4f66ef2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f573741a4f66ef2e$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $f573741a4f66ef2e$var$_react.default.createElement($f573741a4f66ef2e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$f573741a4f66ef2e$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $f573741a4f66ef2e$var$_default = module.exports.default = $f573741a4f66ef2e$var$BriefcaseIcon;

});

parcelRegister("1LeRj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1485b4e646777d05$var$_react = $1485b4e646777d05$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1485b4e646777d05$var$_baseNew = $1485b4e646777d05$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $1485b4e646777d05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1485b4e646777d05$var$ChangesIcon = (props)=>/*#__PURE__*/ $1485b4e646777d05$var$_react.default.createElement($1485b4e646777d05$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$1485b4e646777d05$var$ChangesIcon.displayName = 'ChangesIcon';
var $1485b4e646777d05$var$_default = module.exports.default = $1485b4e646777d05$var$ChangesIcon;

});

parcelRegister("era0o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3a8c88470e968ec08c5aa075e8f42b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a82b592e72d28b05$var$_react = $a82b592e72d28b05$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a82b592e72d28b05$var$_baseNew = $a82b592e72d28b05$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a82b592e72d28b05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBubble".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bubble and matrix charts; Matrix view in in JPD
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a82b592e72d28b05$var$ChartBubbleIcon = (props)=>/*#__PURE__*/ $a82b592e72d28b05$var$_react.default.createElement($a82b592e72d28b05$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M11.27 9.01a1.38 1.38 0 1 1-1.51 1.51l-.01-.14.01-.14A1.38 1.38 0 0 1 11.13 9zM5.75 6.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m4.75-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"/>`
    }, props));
$a82b592e72d28b05$var$ChartBubbleIcon.displayName = 'ChartBubbleIcon';
var $a82b592e72d28b05$var$_default = module.exports.default = $a82b592e72d28b05$var$ChartBubbleIcon;

});

parcelRegister("iZu54", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d0119e14b14178352097aaf532e33e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd3541ec470c3c13$var$_react = $dd3541ec470c3c13$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dd3541ec470c3c13$var$_baseNew = $dd3541ec470c3c13$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $dd3541ec470c3c13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartMatrix".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Matrix view in in JPD, and other matrix charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd3541ec470c3c13$var$ChartMatrixIcon = (props)=>/*#__PURE__*/ $dd3541ec470c3c13$var$_react.default.createElement($dd3541ec470c3c13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8 4.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.25 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5.5 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2m5.5-9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m8 3.5a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M10.5 8A1.75 1.75 0 1 1 14 8a1.75 1.75 0 0 1-3.5 0m-5 2.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$dd3541ec470c3c13$var$ChartMatrixIcon.displayName = 'ChartMatrixIcon';
var $dd3541ec470c3c13$var$_default = module.exports.default = $dd3541ec470c3c13$var$ChartMatrixIcon;

});

parcelRegister("7ilxc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54faeb292ecf7d1f$var$_react = $54faeb292ecf7d1f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $54faeb292ecf7d1f$var$_baseNew = $54faeb292ecf7d1f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $54faeb292ecf7d1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $54faeb292ecf7d1f$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $54faeb292ecf7d1f$var$_react.default.createElement($54faeb292ecf7d1f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$54faeb292ecf7d1f$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $54faeb292ecf7d1f$var$_default = module.exports.default = $54faeb292ecf7d1f$var$CheckboxCheckedIcon;

});

parcelRegister("fhgNY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1f57aa6b89a634a$var$_react = $b1f57aa6b89a634a$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b1f57aa6b89a634a$var$_baseNew = $b1f57aa6b89a634a$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $b1f57aa6b89a634a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1f57aa6b89a634a$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b1f57aa6b89a634a$var$_react.default.createElement($b1f57aa6b89a634a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b1f57aa6b89a634a$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b1f57aa6b89a634a$var$_default = module.exports.default = $b1f57aa6b89a634a$var$CloudArrowUpIcon;

});

parcelRegister("9ghqh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e9795e597b52fb83fbace5cb1978ff6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6be31f7c0a64a3c5$var$_react = $6be31f7c0a64a3c5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6be31f7c0a64a3c5$var$_baseNew = $6be31f7c0a64a3c5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6be31f7c0a64a3c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFlow".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Database schema in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6be31f7c0a64a3c5$var$DataFlowIcon = (props)=>/*#__PURE__*/ $6be31f7c0a64a3c5$var$_react.default.createElement($6be31f7c0a64a3c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.75 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5H9.563C8.976 3 8.5 3.476 8.5 4.063V7.25h3.128a2.251 2.251 0 1 1 0 1.5H8.5v3.188c0 .586.476 1.062 1.063 1.062h2.065a2.251 2.251 0 1 1 0 1.5H9.563A2.563 2.563 0 0 1 7 11.938V8.75H4.372a2.25 2.25 0 1 1 0-1.5H7V4.063A2.56 2.56 0 0 1 9.563 1.5zM2.25 7.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m11.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0 5.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$6be31f7c0a64a3c5$var$DataFlowIcon.displayName = 'DataFlowIcon';
var $6be31f7c0a64a3c5$var$_default = module.exports.default = $6be31f7c0a64a3c5$var$DataFlowIcon;

});

parcelRegister("iSCOr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::012d66b4638df27988cb46b8baf9afaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbeb60837b8587ed$var$_react = $dbeb60837b8587ed$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dbeb60837b8587ed$var$_baseNew = $dbeb60837b8587ed$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $dbeb60837b8587ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldCheckboxGroup".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Checkbox group field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbeb60837b8587ed$var$FieldCheckboxGroupIcon = (props)=>/*#__PURE__*/ $dbeb60837b8587ed$var$_react.default.createElement($dbeb60837b8587ed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 2.75A.75.75 0 0 1 1.75 2h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5A.75.75 0 0 1 1 6.25zm1.5.75v2h2v-2zM16 5.25H8v-1.5h8zM1 9.75A.75.75 0 0 1 1.75 9h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75zm1.5.75v2h2v-2zM16 12.25H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$dbeb60837b8587ed$var$FieldCheckboxGroupIcon.displayName = 'FieldCheckboxGroupIcon';
var $dbeb60837b8587ed$var$_default = module.exports.default = $dbeb60837b8587ed$var$FieldCheckboxGroupIcon;

});

parcelRegister("biJi9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a72127bfc0e3d91a970ca1d9129c37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83a4822407e99dc6$var$_react = $83a4822407e99dc6$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $83a4822407e99dc6$var$_baseNew = $83a4822407e99dc6$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $83a4822407e99dc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Flag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: flags in Editor, feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83a4822407e99dc6$var$FlagIcon = (props)=>/*#__PURE__*/ $83a4822407e99dc6$var$_react.default.createElement($83a4822407e99dc6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.22 1.22A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2V1.75a.75.75 0 0 1 .22-.53M3.5 9h9l-2.1-2.8a.75.75 0 0 1 0-.9l2.1-2.8h-9z" clip-rule="evenodd"/>`
    }, props));
$83a4822407e99dc6$var$FlagIcon.displayName = 'FlagIcon';
var $83a4822407e99dc6$var$_default = module.exports.default = $83a4822407e99dc6$var$FlagIcon;

});

parcelRegister("3AJLg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29d83b27cecfd60b$var$_react = $29d83b27cecfd60b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $29d83b27cecfd60b$var$_baseNew = $29d83b27cecfd60b$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $29d83b27cecfd60b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29d83b27cecfd60b$var$FormIcon = (props)=>/*#__PURE__*/ $29d83b27cecfd60b$var$_react.default.createElement($29d83b27cecfd60b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$29d83b27cecfd60b$var$FormIcon.displayName = 'FormIcon';
var $29d83b27cecfd60b$var$_default = module.exports.default = $29d83b27cecfd60b$var$FormIcon;

});

parcelRegister("6UXAj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50963153fc855bc9$var$_react = $50963153fc855bc9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $50963153fc855bc9$var$_baseNew = $50963153fc855bc9$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $50963153fc855bc9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50963153fc855bc9$var$GoalIcon = (props)=>/*#__PURE__*/ $50963153fc855bc9$var$_react.default.createElement($50963153fc855bc9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$50963153fc855bc9$var$GoalIcon.displayName = 'GoalIcon';
var $50963153fc855bc9$var$_default = module.exports.default = $50963153fc855bc9$var$GoalIcon;

});

parcelRegister("dNlyT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7b5804889990b150be57e7707dfe0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0b093aad4bb76da$var$_react = $a0b093aad4bb76da$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a0b093aad4bb76da$var$_baseNew = $a0b093aad4bb76da$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a0b093aad4bb76da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0b093aad4bb76da$var$GridIcon = (props)=>/*#__PURE__*/ $a0b093aad4bb76da$var$_react.default.createElement($a0b093aad4bb76da$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$a0b093aad4bb76da$var$GridIcon.displayName = 'GridIcon';
var $a0b093aad4bb76da$var$_default = module.exports.default = $a0b093aad4bb76da$var$GridIcon;

});

parcelRegister("fonh7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de887aadbfedd5e674ee79e9bf8242ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b34b26d834178e56$var$_react = $b34b26d834178e56$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b34b26d834178e56$var$_baseNew = $b34b26d834178e56$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $b34b26d834178e56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b34b26d834178e56$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $b34b26d834178e56$var$_react.default.createElement($b34b26d834178e56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h4v1.5H8.75v1.75h.92a4.75 4.75 0 0 1 4.72 4.225l.355 3.192A.75.75 0 0 1 14 12.5H2a.75.75 0 0 1-.745-.833l.354-3.192A4.75 4.75 0 0 1 6.33 4.25h.92V2.5H6zm.33 4.75A3.25 3.25 0 0 0 3.1 8.641L2.838 11h10.324L12.9 8.641A3.25 3.25 0 0 0 9.67 5.75zM15 13.5V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$b34b26d834178e56$var$LobbyBellIcon.displayName = 'LobbyBellIcon';
var $b34b26d834178e56$var$_default = module.exports.default = $b34b26d834178e56$var$LobbyBellIcon;

});

parcelRegister("ck1qR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b57d69a7e6f53846886bde82f36883e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f8876b0e978f062$var$_react = $8f8876b0e978f062$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8f8876b0e978f062$var$_baseNew = $8f8876b0e978f062$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $8f8876b0e978f062$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f8876b0e978f062$var$MagicWandIcon = (props)=>/*#__PURE__*/ $8f8876b0e978f062$var$_react.default.createElement($8f8876b0e978f062$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.027 3.911a1.376 1.376 0 0 1 1.841-.094l.105.094 1.116 1.116a1.376 1.376 0 0 1 0 1.946l-8.616 8.616a1.376 1.376 0 0 1-1.946 0L.411 14.473a1.376 1.376 0 0 1 0-1.946zM1.561 13.5l.939.94L7.938 9 7 8.061zm13.431-4.067-1.06 1.06-1.415-1.414 1.061-1.06zM8.061 7l.938.938L10.939 6l-.94-.94zM16 5v1.5h-2V5zM7.982 2.422l-1.06 1.06-1.414-1.414 1.06-1.06zm7.01-.354-1.414 1.414-1.06-1.06 1.414-1.414zM11 0v2H9.5V0z"/>`
    }, props));
$8f8876b0e978f062$var$MagicWandIcon.displayName = 'MagicWandIcon';
var $8f8876b0e978f062$var$_default = module.exports.default = $8f8876b0e978f062$var$MagicWandIcon;

});

parcelRegister("iBtIB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed07350d21c7e2ad94ff4198361d506>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $037ec0f846817020$var$_react = $037ec0f846817020$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $037ec0f846817020$var$_baseNew = $037ec0f846817020$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $037ec0f846817020$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $037ec0f846817020$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $037ec0f846817020$var$_react.default.createElement($037ec0f846817020$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$037ec0f846817020$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
var $037ec0f846817020$var$_default = module.exports.default = $037ec0f846817020$var$MarketplaceIcon;

});

parcelRegister("cOWmd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95576c15b59f6f99$var$_react = $95576c15b59f6f99$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $95576c15b59f6f99$var$_baseNew = $95576c15b59f6f99$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $95576c15b59f6f99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95576c15b59f6f99$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $95576c15b59f6f99$var$_react.default.createElement($95576c15b59f6f99$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$95576c15b59f6f99$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $95576c15b59f6f99$var$_default = module.exports.default = $95576c15b59f6f99$var$MegaphoneIcon;

});

parcelRegister("ax2O9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6209776ef69c56f26af2970fd840a919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aaf2a0eb695d083$var$_react = $7aaf2a0eb695d083$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7aaf2a0eb695d083$var$_baseNew = $7aaf2a0eb695d083$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7aaf2a0eb695d083$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aaf2a0eb695d083$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $7aaf2a0eb695d083$var$_react.default.createElement($7aaf2a0eb695d083$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$7aaf2a0eb695d083$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
var $7aaf2a0eb695d083$var$_default = module.exports.default = $7aaf2a0eb695d083$var$ObjectiveIcon;

});

parcelRegister("hz0ya", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30e149500cf1a05a183dbc43511b361c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc9621c5d990e12c$var$_react = $cc9621c5d990e12c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cc9621c5d990e12c$var$_baseNew = $cc9621c5d990e12c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cc9621c5d990e12c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc9621c5d990e12c$var$OperationsIcon = (props)=>/*#__PURE__*/ $cc9621c5d990e12c$var$_react.default.createElement($cc9621c5d990e12c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$cc9621c5d990e12c$var$OperationsIcon.displayName = 'OperationsIcon';
var $cc9621c5d990e12c$var$_default = module.exports.default = $cc9621c5d990e12c$var$OperationsIcon;

});

parcelRegister("5SjQD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44716444b1e41481$var$_react = $44716444b1e41481$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $44716444b1e41481$var$_baseNew = $44716444b1e41481$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $44716444b1e41481$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44716444b1e41481$var$PagesIcon = (props)=>/*#__PURE__*/ $44716444b1e41481$var$_react.default.createElement($44716444b1e41481$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$44716444b1e41481$var$PagesIcon.displayName = 'PagesIcon';
var $44716444b1e41481$var$_default = module.exports.default = $44716444b1e41481$var$PagesIcon;

});

parcelRegister("czSoI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9282f322805ee7c4$var$_react = $9282f322805ee7c4$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9282f322805ee7c4$var$_baseNew = $9282f322805ee7c4$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $9282f322805ee7c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9282f322805ee7c4$var$PersonAddIcon = (props)=>/*#__PURE__*/ $9282f322805ee7c4$var$_react.default.createElement($9282f322805ee7c4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$9282f322805ee7c4$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $9282f322805ee7c4$var$_default = module.exports.default = $9282f322805ee7c4$var$PersonAddIcon;

});

parcelRegister("hA8Qq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::975f3556f302c98e53e9a5c512ff1020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cccca8cfb09450cd$var$_react = $cccca8cfb09450cd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cccca8cfb09450cd$var$_baseNew = $cccca8cfb09450cd$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cccca8cfb09450cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cccca8cfb09450cd$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $cccca8cfb09450cd$var$_react.default.createElement($cccca8cfb09450cd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.628.896-2.276a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$cccca8cfb09450cd$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $cccca8cfb09450cd$var$_default = module.exports.default = $cccca8cfb09450cd$var$PresenterModeIcon;

});

parcelRegister("hBIcK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff5f3689a11c3468e5139786a8e64251>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd182e7734303b34$var$_react = $cd182e7734303b34$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cd182e7734303b34$var$_baseNew = $cd182e7734303b34$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cd182e7734303b34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMajor".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for major work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cd182e7734303b34$var$PriorityMajorIcon = (props)=>/*#__PURE__*/ $cd182e7734303b34$var$_react.default.createElement($cd182e7734303b34$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 4.75-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625L2.913 6 8 2.65 13.087 6zm0 4.5-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353zm0 4.5-5.5-3.626a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 11.65l5.087 3.353z"/>`
    }, props));
$cd182e7734303b34$var$PriorityMajorIcon.displayName = 'PriorityMajorIcon';
var $cd182e7734303b34$var$_default = module.exports.default = $cd182e7734303b34$var$PriorityMajorIcon;

});

parcelRegister("7doBf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc58ff4eb916aa4715fd29d4da19740a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $540cd44dc8e6039e$var$_react = $540cd44dc8e6039e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $540cd44dc8e6039e$var$_baseNew = $540cd44dc8e6039e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $540cd44dc8e6039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $540cd44dc8e6039e$var$ProjectIcon = (props)=>/*#__PURE__*/ $540cd44dc8e6039e$var$_react.default.createElement($540cd44dc8e6039e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$540cd44dc8e6039e$var$ProjectIcon.displayName = 'ProjectIcon';
var $540cd44dc8e6039e$var$_default = module.exports.default = $540cd44dc8e6039e$var$ProjectIcon;

});

parcelRegister("qz5Fw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04fda60d28122c84$var$_react = $04fda60d28122c84$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $04fda60d28122c84$var$_baseNew = $04fda60d28122c84$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $04fda60d28122c84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04fda60d28122c84$var$ScreenIcon = (props)=>/*#__PURE__*/ $04fda60d28122c84$var$_react.default.createElement($04fda60d28122c84$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$04fda60d28122c84$var$ScreenIcon.displayName = 'ScreenIcon';
var $04fda60d28122c84$var$_default = module.exports.default = $04fda60d28122c84$var$ScreenIcon;

});

parcelRegister("3w1ji", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02df73cd5dddff20d82e48f58fe7ce92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28f5606a9a13cc58$var$_react = $28f5606a9a13cc58$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $28f5606a9a13cc58$var$_baseNew = $28f5606a9a13cc58$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $28f5606a9a13cc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28f5606a9a13cc58$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $28f5606a9a13cc58$var$_react.default.createElement($28f5606a9a13cc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$28f5606a9a13cc58$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $28f5606a9a13cc58$var$_default = module.exports.default = $28f5606a9a13cc58$var$ShowMoreVerticalIcon;

});

parcelRegister("fq25Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0cf5658da3b79d5f876ad9c272a691a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b39ae860c380c09c$var$_react = $b39ae860c380c09c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b39ae860c380c09c$var$_baseNew = $b39ae860c380c09c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $b39ae860c380c09c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b39ae860c380c09c$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $b39ae860c380c09c$var$_react.default.createElement($b39ae860c380c09c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$b39ae860c380c09c$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $b39ae860c380c09c$var$_default = module.exports.default = $b39ae860c380c09c$var$SmartLinkListIcon;

});

parcelRegister("8GlZZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::350d68f25c9b4e9b7a6f8128f373fbcc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65234f7ca62870d2$var$_react = $65234f7ca62870d2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $65234f7ca62870d2$var$_baseNew = $65234f7ca62870d2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $65234f7ca62870d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskInProgress".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for in progress task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65234f7ca62870d2$var$TaskInProgressIcon = (props)=>/*#__PURE__*/ $65234f7ca62870d2$var$_react.default.createElement($65234f7ca62870d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h7.646L6.97 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1.542a6.501 6.501 0 1 0 0-1.5M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$65234f7ca62870d2$var$TaskInProgressIcon.displayName = 'TaskInProgressIcon';
var $65234f7ca62870d2$var$_default = module.exports.default = $65234f7ca62870d2$var$TaskInProgressIcon;

});

parcelRegister("9ih0P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b20915105f9f06f3ef89ee9497af0ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c42fdd1b032760e$var$_react = $6c42fdd1b032760e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6c42fdd1b032760e$var$_baseNew = $6c42fdd1b032760e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6c42fdd1b032760e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c42fdd1b032760e$var$TransitionIcon = (props)=>/*#__PURE__*/ $6c42fdd1b032760e$var$_react.default.createElement($6c42fdd1b032760e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$6c42fdd1b032760e$var$TransitionIcon.displayName = 'TransitionIcon';
var $6c42fdd1b032760e$var$_default = module.exports.default = $6c42fdd1b032760e$var$TransitionIcon;

});

parcelRegister("l7rtf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa0a7a20e9878c1f12b50feba4970dc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5ff8f8dc5479751$var$_react = $f5ff8f8dc5479751$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f5ff8f8dc5479751$var$_baseNew = $f5ff8f8dc5479751$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f5ff8f8dc5479751$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5ff8f8dc5479751$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $f5ff8f8dc5479751$var$_react.default.createElement($f5ff8f8dc5479751$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$f5ff8f8dc5479751$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $f5ff8f8dc5479751$var$_default = module.exports.default = $f5ff8f8dc5479751$var$WorkItemsIcon;

});

parcelRegister("1eGzb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a128432aba3d4deb725c4d0760aebb99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e681e0e9ec5f2ef$var$_react = $0e681e0e9ec5f2ef$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0e681e0e9ec5f2ef$var$_baseNew = $0e681e0e9ec5f2ef$var$_interopRequireDefault((parcelRequire("jcI35")));
function $0e681e0e9ec5f2ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Assets graph
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e681e0e9ec5f2ef$var$AssetsGraphIcon = (props)=>/*#__PURE__*/ $0e681e0e9ec5f2ef$var$_react.default.createElement($0e681e0e9ec5f2ef$var$_baseNew.default, Object.assign({
        name: "AssetsGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.78 4.28-1.833 1.832a3.5 3.5 0 0 1 0 3.775l1.833 1.833-1.06 1.06-1.833-1.833a3.5 3.5 0 0 1-3.775 0L4.28 12.78l-1.06-1.06 1.832-1.833a3.5 3.5 0 0 1 0-3.775L3.22 4.28l1.06-1.06 1.832 1.832a3.5 3.5 0 0 1 3.775 0L11.72 3.22zM9.414 6.586a2 2 0 1 0-2.828 2.828 2 2 0 0 0 2.828-2.828"/><path fill="currentcolor" d="M11.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 11.73.73m2.48 1.06A1 1 0 1 0 12.8 3.2a1 1 0 0 0 1.41-1.41m-2.48 9.94a2.5 2.5 0 1 1 3.54 3.53 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06a1 1 0 1 0-1.41 1.41 1 1 0 0 0 1.41-1.41M.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 .73.73m2.48 1.06A1 1 0 1 0 1.8 3.2a1 1 0 0 0 1.41-1.41M.73 11.73a2.5 2.5 0 1 1 3.54 3.53 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06A1 1 0 1 0 1.8 14.2a1 1 0 0 0 1.41-1.41"/>`
    }, props));
$0e681e0e9ec5f2ef$var$AssetsGraphIcon.displayName = 'AssetsGraphIcon';
var $0e681e0e9ec5f2ef$var$_default = module.exports.default = $0e681e0e9ec5f2ef$var$AssetsGraphIcon;

});

parcelRegister("k2zyM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d288013ed94ec7ddbe1bb143e39a4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e96f93ff829ead8b$var$_react = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e96f93ff829ead8b$var$_baseNew = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("jcI35")));
function $e96f93ff829ead8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e96f93ff829ead8b$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $e96f93ff829ead8b$var$_react.default.createElement($e96f93ff829ead8b$var$_baseNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$e96f93ff829ead8b$var$BrowserExtensionIcon.displayName = 'BrowserExtensionIcon';
var $e96f93ff829ead8b$var$_default = module.exports.default = $e96f93ff829ead8b$var$BrowserExtensionIcon;

});

parcelRegister("2GO8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f5663fd08175dde$var$_react = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1f5663fd08175dde$var$_baseNew = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("jcI35")));
function $1f5663fd08175dde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f5663fd08175dde$var$NotepadIcon = (props)=>/*#__PURE__*/ $1f5663fd08175dde$var$_react.default.createElement($1f5663fd08175dde$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$1f5663fd08175dde$var$NotepadIcon.displayName = 'NotepadIcon';
var $1f5663fd08175dde$var$_default = module.exports.default = $1f5663fd08175dde$var$NotepadIcon;

});

parcelRegister("8BlKa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6432a540254daa54$var$_react = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6432a540254daa54$var$_baseNew = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6432a540254daa54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6432a540254daa54$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $6432a540254daa54$var$_react.default.createElement($6432a540254daa54$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$6432a540254daa54$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $6432a540254daa54$var$_default = module.exports.default = $6432a540254daa54$var$RoadmapsPlanIcon;

});

parcelRegister("lUMmm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff445725fe4e8cde$var$_react = $ff445725fe4e8cde$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ff445725fe4e8cde$var$_baseNew = $ff445725fe4e8cde$var$_interopRequireDefault((parcelRequire("jcI35")));
function $ff445725fe4e8cde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff445725fe4e8cde$var$RovoIcon = (props)=>/*#__PURE__*/ $ff445725fe4e8cde$var$_react.default.createElement($ff445725fe4e8cde$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$ff445725fe4e8cde$var$RovoIcon.displayName = 'RovoIcon';
var $ff445725fe4e8cde$var$_default = module.exports.default = $ff445725fe4e8cde$var$RovoIcon;

});

parcelRegister("6xXDI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c441650e47ff0d3$var$_react = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c441650e47ff0d3$var$_baseNew = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("jcI35")));
function $4c441650e47ff0d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c441650e47ff0d3$var$SyncIcon = (props)=>/*#__PURE__*/ $4c441650e47ff0d3$var$_react.default.createElement($4c441650e47ff0d3$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$4c441650e47ff0d3$var$SyncIcon.displayName = 'SyncIcon';
var $4c441650e47ff0d3$var$_default = module.exports.default = $4c441650e47ff0d3$var$SyncIcon;

});

parcelRegister("f1MsQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6dad959d4748daed02c67a782b9b76e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af0c8afa9834d472$var$_react = $af0c8afa9834d472$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $af0c8afa9834d472$var$_baseNew = $af0c8afa9834d472$var$_interopRequireDefault((parcelRequire("jcI35")));
function $af0c8afa9834d472$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextAudioTranscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for viewing transcript in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af0c8afa9834d472$var$TextAudioTranscriptIcon = (props)=>/*#__PURE__*/ $af0c8afa9834d472$var$_react.default.createElement($af0c8afa9834d472$var$_baseNew.default, Object.assign({
        name: "TextAudioTranscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 0H2v1.5h14zM6 5.105C6 4.315 5.418 3.5 4.5 3.5S3 4.314 3 5.105v3.29C3 9.185 3.582 10 4.5 10S6 9.186 6 8.395zm10-.939H8.959v1.5H16zm0 4.167h-5v1.5h5zm-8.5.062v.073c0 1.699-1.328 3.052-3 3.052s-3-1.353-3-3.052v-.073H0v.073c0 2.247 1.593 4.131 3.75 4.49V14.5H1.5V16h6v-1.5H5.25v-1.542C7.407 12.6 9 10.715 9 8.468v-.073zm8.5 4.104h-5v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$af0c8afa9834d472$var$TextAudioTranscriptIcon.displayName = 'TextAudioTranscriptIcon';
var $af0c8afa9834d472$var$_default = module.exports.default = $af0c8afa9834d472$var$TextAudioTranscriptIcon;

});

parcelRegister("5nJnO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5412db8dd6dbd639e997b10aa14b104a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb24de21519b485$var$_react = $3eb24de21519b485$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3eb24de21519b485$var$_baseNew = $3eb24de21519b485$var$_interopRequireDefault((parcelRequire("jcI35")));
function $3eb24de21519b485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Views".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing saved views.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb24de21519b485$var$ViewsIcon = (props)=>/*#__PURE__*/ $3eb24de21519b485$var$_react.default.createElement($3eb24de21519b485$var$_baseNew.default, Object.assign({
        name: "ViewsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 5.5H6v6h5a.5.5 0 0 0 .5-.5zm-9 5.5a.5.5 0 0 0 .5.5h1.5v-6h-2zm9-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1h9zm1.5 8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 12.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$3eb24de21519b485$var$ViewsIcon.displayName = 'ViewsIcon';
var $3eb24de21519b485$var$_default = module.exports.default = $3eb24de21519b485$var$ViewsIcon;

});



//# sourceMappingURL=jira-software-page.cb47cee8.js.map
